import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { preserveMathCursorPosition } from "@/components/tiptap/utils/preserveMathCursorPosition";

import { appendBlock } from "../create-blocks/utils/appendBlock";
import { getCollapsedButtonProps } from "../getCollapsedButtonProps";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  isCollapsed?: boolean;
  className?: string;
};

export const CalloutButton = observer(function CalloutButton({
  doc,
  isCollapsed,
  className,
}: Props) {
  const t = useTranslations("sidebar.createBlocks");
  const { tiptap, editorState } = doc.editor;

  if (!tiptap) {
    return null;
  }

  const handleOnClick = () => {
    if (editorState.isNonConvertableBlock && !editorState.isImage) {
      appendBlock(doc, "callout");
      return;
    }

    preserveMathCursorPosition(doc, () => {
      tiptap.chain().unsetBlockquote().toggleCallout().run();
    });
  };

  return (
    <Sidebar.Button
      data-testid="callout-block-type"
      icon={<Icon name="block-format/Callout" />}
      title={t("callout.title")}
      onClick={handleOnClick}
      isActive={editorState.isCallout}
      aria-pressed={editorState.isCallout}
      inverted
      className={className}
      {...getCollapsedButtonProps(isCollapsed)}
    />
  );
});
